<template>
    <div id="wa-busines-customer-groups">
        <div class="main-content">
            <div class="header">
                <div class="title">
                    <div class="title-content">
                        <span @click="selectedCustomerGroup = null" style="cursor: pointer">
                            {{ $t("wp.customerGroups") }}
                        </span>

                        <span v-if="selectedCustomerGroup"> > {{ selectedCustomerGroup.name }} </span>
                    </div>
                    <a-popover
                        :visible="createCustomerGroupFormVisible"
                        placement="bottom"
                        @visibleChange="changeCreateGroupPopupVisible"
                        trigger="click"
                    >
                        <div slot="content">
                            <CreateCustomerGroupWithNumbers
                                :contacts="[]"
                                :on-cancelled="() => changeCreateGroupPopupVisible(false)"
                                :on-completed="customerGroupCreated"
                                :isBusiness="isBusiness"
                            />
                        </div>

                        <div
                            class="add-button"
                            v-if="!selectedCustomerGroup"
                            v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                            :content="$t('wp.createCustomerGroup')"
                        >
                            <md-icon>add</md-icon>
                        </div>
                    </a-popover>
                </div>
                <div v-if="!selectedCustomerGroup" class="search-bar">
                    <input v-model="searchText" :placeholder="$t('wp.search')" />
                    <md-icon>search</md-icon>
                </div>
                <div v-else class="search-bar">
                    <input
                        v-model="predictiveText"
                        placeholder="Search"
                        @keydown.enter="searchTextOfSelected = predictiveText"
                    />
                    <md-icon>search</md-icon>
                </div>
            </div>
            <div class="group-list-wrapper">
                <CustomerGroupDetail
                    v-if="
                        !!customerGroups[
                            customerGroups.findIndex((cg) => cg._id === $_.get(selectedCustomerGroup, '_id'))
                        ]
                    "
                    v-model="
                        customerGroups[
                            customerGroups.findIndex((cg) => cg._id === $_.get(selectedCustomerGroup, '_id'))
                        ]
                    "
                    :key="
                        $_.get(
                            customerGroups[
                                customerGroups.findIndex((cg) => cg._id === $_.get(selectedCustomerGroup, '_id'))
                            ],
                            '_id'
                        )
                    "
                    :searchTextOfSelected="searchTextOfSelected"
                    :channel-id="channelId"
                    :isWhatsappBusiness="isWhatsappBusiness() || isBusiness"
                />
                <CustomerGroupsTable
                    v-else
                    :groups="getFilteredRows()"
                    :on-row-selected="selectCustomerGroup"
                    :on-row-deleted="customerGroupDeleted"
                />
            </div>
        </div>
    </div>
</template>

<script>
import WHATSAPP_API from "../../../../../api/whatsapp";
import { mapState } from "vuex";
import Fuse from "fuse.js";
import CustomerGroupsTable from "../../../Whatsapp/components/CustomerGroupsTable.vue";
import CustomerGroupDetail from "../../../Whatsapp/pages/broadcast/CustomerGroupDetail.vue";
import CreateCustomerGroupWithNumbers from "../../../Whatsapp/pages/contact-list/CreateCustomerGroupWithNumbers.vue";
import log2 from "../../../../../utils/log2";

const log = log2("CustomerGroups");

const columns = [
    {
        dataIndex: "avatar",
        key: "avatar",
        slots: { title: "" },
        scopedSlots: { customRender: "avatar" },
        width: "5%",
    },
    {
        dataIndex: "name",
        key: "name",
        title: "Name",
        scopedSlots: { customRender: "name" },
    },
    {
        dataIndex: "description",
        key: "description",
        title: "Description",
        scopedSlots: { customRender: "description" },
    },
    {
        dataIndex: "contacts",
        key: "contacts",
        title: "Contacts",
        scopedSlots: { customRender: "contacts" },
    },
    {
        title: "Action",
        key: "action",
        scopedSlots: { customRender: "action" },
    },
];

export default {
    name: "CustomerGroups",
    components: {
        CustomerGroupsTable,
        CustomerGroupDetail,
        CreateCustomerGroupWithNumbers,
    },
    data() {
        return {
            columns,
            loading: true,
            customerGroups: [],
            selectedCustomerGroup: null,
            createCustomerGroupFormVisible: false,
            searchText: "",
            searchTextOfSelected: "",
            predictiveText: "",
            loadingInstance: null,
        };
    },
    props: {
        channelId: {
            type: String,
        },
        isBusiness: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            siteId: (state) => state.site.site._id,
            settings: (state) => state.setting.settings,
            channels: (state) => state.channel.channels,
        }),
    },
    methods: {
        isWhatsappBusiness() {
            return this.channels.find((channel) => channel._id === this.channelId)?.type === "whatsapp-business-api";
        },
        selectCustomerGroup(group) {
            log("selectCustomerGroup", group);
            this.selectedCustomerGroup = group;
        },
        changeCreateGroupPopupVisible(visible) {
            this.createCustomerGroupFormVisible = visible;
        },
        getFilteredRows() {
            log("this.customerGroups", this.customerGroups);
            let fuzzySearch = new Fuse(this.customerGroups, { keys: ["name", "id"] });
            const filteredRows =
                this.searchText.length > 0
                    ? fuzzySearch.search(this.searchText).map((x) => x.item)
                    : this.customerGroups;
            log("filteredRow", filteredRows);
            return filteredRows;
        },
        customerGroupCreated(group) {
            this.createCustomerGroupFormVisible = false;
            this.customerGroups = [group, ...this.customerGroups];
            setTimeout(() => {
                this.selectCustomerGroup(group);
            }, 1000);
        },
        customerGroupDeleted(id) {
            this.customerGroups = this.customerGroups.filter((group) => group._id !== id);
        },
        fetchCustomerGroups() {
            this.loadingInstance?.show();
            WHATSAPP_API.BROADCAST.listGroups()
                .then((res) => {
                    this.customerGroups = res.data;
                })
                .finally(() => {
                    this.loadingInstance?.close();
                });
        },
    },
    mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector(".customer-groups-table"),
            name: "wave",
        });
        this.fetchCustomerGroups();
        setTimeout(() => {
            log("customerGroups", this.customerGroups);
        }, 1000);
    },
    watch: {
        selectedCustomerGroup() {
            log("selectedCustomerGroup", this.selectedCustomerGroup);
        },
    },
};
</script>

<style lang="scss" scoped>
#wa-busines-customer-groups {
    .main-content {
        width: 100%;
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        overflow: auto;

        .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            position: sticky;
            top: 0px;
            z-index: 20;
            background: white;

            .title {
                display: flex;
                justify-content: center;
                align-items: center;

                .title-content {
                    color: #22272d;
                    font-weight: 500;
                    line-height: 31px;
                    font-size: 24px;
                }

                .add-button {
                    background-color: #008aff;
                    border-radius: 9999px;
                    padding: 3px;
                    margin-left: 15px;
                    cursor: pointer;
                    -webkit-transition: 0.3s;
                    transition: 0.3s;

                    i {
                        color: white;
                    }
                }
            }

            .search-bar {
                display: flex;
                justify-content: space-between;
                position: relative;

                input {
                    width: 100%;
                    outline: none;
                    height: 40px;
                    color: #22272d;
                    border: 1px solid #c6cdd4;
                    border-radius: 6px;
                    padding: 9px 35px 9px 17px;
                    font-size: 14px;
                    line-height: 20px;
                }

                i {
                    position: absolute;
                    right: 5px;
                    top: 7px;
                    color: #c6cdd4;
                }
            }
        }
    }
}
</style>
